import type { Tel } from '@w/tel'
import { useState } from 'react'
import { useQuery } from '@w/react-query'
import { Button } from '@w/ui/components/button'
import { failureListOptions } from './entries'
import { FailurePanel, unmatchedLetters } from './panel'
import type { SpaceResource } from '../router/spaces-resources'

export function WorkspaceFailures({ resource, tel }: { resource: SpaceResource; tel: Tel }) {
  const result = useQuery(failureListOptions(resource, tel), resource.queryClient)
  const [open, setOpen] = useState(false)
  const entries = result.error ? [] : result.data ?? []
  // Refused custom-database writes no listed page failure replays (panel.tsx unmatchedLetters).
  const unmatched = useQuery({
    queryKey: ['workspace-unmatched-letters', resource.connectionId, entries.map(entry => [entry.id, entry.status, entry.source])],
    queryFn: () => unmatchedLetters(resource, entries),
    subscribe: (invalidate: () => void) => resource.deadLetters.subscribe(invalidate),
  }, resource.queryClient)
  const letters = unmatched.error ? [] : unmatched.data ?? []
  const count = entries.filter(entry => entry.status === 'failed').length + letters.length
  const pending = entries.filter(entry => entry.status === 'pending').length
  return <>
    {result.error ? <p role="alert">Failure details unavailable</p> : null}
    {count > 0 ? <p role="status">Some items need attention ({count})</p> : null}
    {pending > 0 ? <p role="status">Retry pending ({pending})</p> : null}
    {entries.length + letters.length > 0 ? <Button onClick={() => { setOpen(!open) }}>{open ? 'Hide failures' : 'View failures'}</Button> : null}
    {open && entries.length + letters.length > 0 ? <FailurePanel resource={resource} tel={tel} entries={entries} letters={letters} /> : null}
  </>
}
